import { ADD_CREDIT_CARD } from '../Actions/actionTypes';

export default (state={},action)=>{
    switch(action.type){

        case ADD_CREDIT_CARD:
            return action.payload;
        default:
            return state;
    }
}